import Img, { FluidObject } from 'gatsby-image'
import React from 'react'

type ImageType = {
  url: string
  alt: string
  fluid: FluidObject
}

export type CompanyAndRepresentativeModalTemplateProps = {
  image: ImageType
  secondaryImage?: ImageType
  title: string
  subtitle: string
  text: {
    html: string
  }
  links: {
    url: string
    label: string
  }[]
}

const CompanyAndRepresentativeModalTemplate = ({
  content
}: {
  content: CompanyAndRepresentativeModalTemplateProps
}) => {
  return (
    <div className='company-rep-modal'>
      {/* desktop: full-bleed portrait panel anchoring the left edge */}
      {content.image && (
        <div className='company-rep-modal__portrait company-rep-modal__portrait--bleed'>
          <Img
            className='h-100 w-100'
            imgStyle={{ objectFit: 'cover' }}
            {...content.image}
          />
        </div>
      )}

      <div className='company-rep-modal__body'>
        <div className='company-rep-modal__header'>
          <div className='company-rep-modal__intro'>
            {content.secondaryImage && (
              <div className='company-rep-modal__logo'>
                {/* plain img so the logo can size by a consistent height
                    (gatsby-image fluid is width-driven and renders short
                    logos tiny inside a fixed box) */}
                <img
                  src={content.secondaryImage.url}
                  alt={content.secondaryImage.alt}
                />
              </div>
            )}

            <h4 className='company-rep-modal__name'>{content.title}</h4>
            {content.subtitle && (
              <p className='company-rep-modal__role'>{content.subtitle}</p>
            )}
          </div>

          {/* mobile: square portrait box beside the logo + name */}
          {content.image && (
            <div className='company-rep-modal__portrait company-rep-modal__portrait--inset'>
              <Img
                className='h-100 w-100'
                imgStyle={{ objectFit: 'cover' }}
                {...content.image}
              />
            </div>
          )}
        </div>

        {content.text?.html && (
          <div
            className='company-rep-modal__bio'
            dangerouslySetInnerHTML={{ __html: content.text.html }}
          />
        )}

        {content.links.length > 0 && (
          <div className='company-rep-modal__links'>
            {content.links.map((link, key) => (
              <a
                key={key}
                className='company-rep-modal__link'
                href={link.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CompanyAndRepresentativeModalTemplate
